import {connect} from 'react-redux';
import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import LanguageSelect from './LanguageSelect';
import * as RoutePaths from '../../constants/RoutePaths';

import imgFMc from '../../static/img/f-mc.png';
import imgFPp from '../../static/img/f-pp.png';
import imgFVisa from '../../static/img/f-visa.png';

class Footer extends Component {
    render() {
        const i18n = this.props.i18n;
        return (
            <footer>
                <div className="wide1245">
                    <a href="/" className="logo">Rentamanía</a>
                    <nav>
                        <ul>
                            <li>
                                <Link to={RoutePaths.CONTACTS}>{i18n['layout.contacts']}</Link>
                            </li>
                            <li>
                                <Link to={RoutePaths.AGREEMENT_CANCELLATION}>{i18n['layout.cancellationPolicy']}</Link>
                            </li>
                            <li>
                                <Link to={RoutePaths.AGREEMENT}>{i18n['layout.termsOfService']}</Link>
                            </li>
                            <li>
                                <Link to={RoutePaths.HELP}>{i18n['layout.help']}</Link>
                            </li>
                        </ul>
                    </nav>
                    <div className="phone">
                        <i />
                        <a href={`tel:${this.props.callbackNumber}`}>&nbsp;{this.props.callbackNumber}</a>
                    </div>
                </div>
                <div className="wide1245 bottom-line">
                    <div className="copyright">© 2017 Rentamanía</div>
                    <LanguageSelect />
                    <ul className="payments">
                        <li><img src={imgFVisa} alt="" /></li>
                        <li><img src={imgFMc} alt="" /></li>
                        <li><img src={imgFPp} alt="" /></li>
                    </ul>
                    <div className="phone">
                        <i />
                        <span>
                            <a href={`tel:${this.props.callbackNumber}`}>&nbsp;{this.props.callbackNumber}</a>
                        </span>
                    </div>
                </div>
                <div className="footer-mobile">
                    <div className="wide1245">
                        <a href="/" className="logo">Rentamanía</a>
                        <LanguageSelect />
                        <div className="phone">
                            <i />
                            <span>
                                <a href={`tel:${this.props.callbackNumber}`}>&nbsp;{this.props.callbackNumber}</a>
                            </span>
                        </div>
                    </div>
                    <nav>
                        <ul>
                            <li>
                                <Link to={RoutePaths.CONTACTS}>{i18n['layout.contacts']}</Link>
                            </li>
                            <li>
                                <Link to={RoutePaths.AGREEMENT_CANCELLATION}>{i18n['layout.cancellationPolicy']}</Link>
                            </li>
                            <li>
                                <Link to={RoutePaths.AGREEMENT}>{i18n['layout.termsOfService']}</Link>
                            </li>
                            <li>
                                <Link to={RoutePaths.HELP}>{i18n['layout.help']}</Link>
                            </li>
                        </ul>
                    </nav>
                    <ul className="payments">
                        <li><img src={imgFVisa} alt="" /></li>
                        <li><img src={imgFMc} alt="" /></li>
                        <li><img src={imgFPp} alt="" /></li>
                    </ul>
                    <div className="copyright">{this.props.copyright}</div>
                </div>
            </footer>
        )
    }
}

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    copyright: state.configuration.main.copyright,
    callbackNumber: state.configuration.main.callbackNumber
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/Base/Footer.js